import { getAppointmentDocument } from "api/Appointment";
import { UseQueryOptions, useQuery } from "react-query";

interface DocumentParams {
  appointment_id?: any;
}

export const useAppointmentDocument = (
  params: DocumentParams,
  options?: UseQueryOptions<any, any, unknown, string[]>
) => {
  const queryInfo = useQuery(
    ['appointmentDocument'],
    () => getAppointmentDocument(params),
    {
      onError: (err) => {
        console.error(err);
      },
      ...options,
      enabled: false,
    }
  );

  return queryInfo;
};